import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45b4a3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26.578",
  height: "18.773",
  viewBox: "0 0 26.578 18.773",
  class: "svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  id: "Path_553",
  "data-name": "Path 553",
  d: "M2536.1-221.405l7.184,7.184,15.152-15.152",
  transform: "translate(-2533.974 231.495)",
  fill: "none",
  stroke: "#1eff44",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.395",
  height: "19.395",
  viewBox: "0 0 19.395 19.395",
  class: "svg _90"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  id: "icon_line_off",
  transform: "translate(2.121 2.122)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M2543.279-214.221l15.152-15.152",
    transform: "translate(-2543.279 229.373)",
    fill: "none",
    stroke: "#ff3d3d",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M2558.432-214.221l-15.152-15.152",
    transform: "translate(-2543.28 229.373)",
    fill: "none",
    stroke: "#ff3d3d",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}